import { render, staticRenderFns } from "./goodsOut.vue?vue&type=template&id=897bfa9e&scoped=true&"
import script from "./goodsOut.vue?vue&type=script&lang=js&"
export * from "./goodsOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897bfa9e",
  null
  
)

export default component.exports